import styles from './Button.module.scss';
import cn from 'classnames';
import { MouseEvent } from 'react';

type ButtonProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  tabIndex?: number;
  variant?: 'dark' | 'secondary' | 'primary';
  icon?: string;
};

export function Button({
  text,
  onClick,
  disabled,
  className,
  type,
  tabIndex,
  variant = 'dark',
  icon,
}: ButtonProps) {
  const buttonClassName = cn(
    styles.button,
    {
      [styles.disabled]: disabled,
      [styles.dark]: variant === 'dark',
      [styles.secondary]: variant === 'secondary',
      [styles.primary]: variant === 'primary',
    },
    className,
  );

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();

    if (disabled) {
      event.preventDefault();
      return;
    }

    onClick();
  };

  return (
    <button
      className={buttonClassName}
      onClick={(e) => handleClick(e)}
      type={type}
      tabIndex={tabIndex}
    >
      {icon && <img src={icon} alt="icon" className={styles.icon} />}
      {text}
    </button>
  );
}
